import Activity from './activity.container'

export default Activity